import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class DpInterestChargesUseCase extends BaseUseCase {
    constructor(DpInterestRepo) {
        super();
        this.DpInterestRepo = DpInterestRepo;
    }
    async fetchResult(req) {
        return await this.DpInterestRepo.getDpInterestCharges(req);
    }
}
export default DpInterestChargesUseCase;
